<!-- Spacer -->
<div
    class="fakturnia-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
